import {backboneCollectionProperties} from "../../decorators/backbone-properties";
import {JurisdictionModel} from "../../settings/models/jurisdiction";

@backboneCollectionProperties({
    model: JurisdictionModel
})
export class JurisdictionCollection extends Backbone.Collection<JurisdictionModel> {

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/settings/collections/jurisdictions.ts